export const itemsMenu = [
  {
    label: 'Editar Perfil',
    item: 'profile',
    link: '/user',
  },
  {
    label: 'Alterar senha',
    item: 'password',
    link: '/user/pass',
  },
];
